import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormArray, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ScrollerModule } from "primeng/scroller";
import { TableModule } from "primeng/table";
import { QuotesInvoiceEmail } from "../../../../core/models/qoutes/quotesInvoiceEmail";
import { CommonModule } from "@angular/common";
import { InputTextModule } from "primeng/inputtext";
import { DropdownModule } from "primeng/dropdown";
import { CheckboxModule } from "primeng/checkbox";

@Component({
  selector: "jni-header-invoice-emails",
  templateUrl: "./header-invoice-emails.component.html",
  styleUrls: ["./header-invoice-emails.component.scss"],
  imports: [
    ReactiveFormsModule,
    TableModule,
    ScrollerModule,
    CommonModule,
    InputTextModule,
    DropdownModule,
    CheckboxModule,
  ],
})
export class HeaderInvoiceEmailsComponent {
  @Input() invoiceListing!: QuotesInvoiceEmail[];
  @Input() parent!: FormGroup;
  @Output() newLine = new EventEmitter<boolean>();
  @Output() removeEmail = new EventEmitter<FormGroup[]>();

  emailSelected!: FormGroup[];

  get invoicedEmails() {
    return (this.parent.get("invoicedEmails") as FormArray).controls;
  }

  onRemoveEmail() {
    if (this.emailSelected) {
      this.removeEmail.emit(this.emailSelected);
      this.emailSelected = [];
    }
  }
}
